<template>
    <template v-if="editing === 'filtering'">
        <div
            v-for="filter in filters"
            :key="filter[0]"
            class="edit filtering-widget"
        >
            <span
                class="material-symbols-outlined icon"
                :class="isFilterActive(active[filter[0]]) ? 'active' : ''"
                @click="cancelFilter(filter[0])"
            >
                {{ filterIconName(active[filter[0]]) }}
            </span>
            {{ filter[1] }}
            <select
                :id="`list-filter-${filter[0]}`"
                v-model="active[filter[0]]"
                @change="onFilterChange($event, filter[0])"
            >
                <option :value="null">All</option>
                <option
                    v-for="[optKey, optName] in filter[2]"
                    :key="optKey"
                    :value="optKey"
                >
                    {{ optName }}
                </option>
            </select>
        </div>
    </template>
    <template v-if="editing === ''">
        <div v-if="hasActive" class="filters-active">
            <span class="material-symbols-outlined icon">filter_list</span>
            {{ getActive }}
        </div>
    </template>
</template>
<script>
export default {
    name: "FilteringWidget",
    props: {
        editing: {
            type: String,
            required: true,
        },
        filters: {
            type: Array,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
    },
    emits: ["update"],
    data() {
        return {
            active: {},
            names: {},
            filterNames: {},
        };
    },
    computed: {
        hasActive() {
            return !!Object.values(this.active).filter((value) => {
                return value !== null && value !== undefined;
            }).length;
        },
        getActive() {
            return Object.keys(this.active)
                .filter((key) => {
                    let value = this.active[key];
                    return value !== null && value !== undefined;
                })
                .map((key) => {
                    return this.filterNames[key][this.active[key]];
                })
                .join(", ");
        },
    },
    mounted() {
        this.filters.forEach((filter) => {
            let [key, name, options] = filter;
            let value = this.query[key];
            this.active[key] = value;
            this.names[key] = name;
            this.filterNames[key] = Object.fromEntries(options);
        });
    },
    methods: {
        onFilterChange(event, filter) {
            let value = event.target.value;
            this.$emit("update", filter, value === "All" ? null : value);
        },
        isFilterActive(value) {
            return value !== null && value !== undefined;
        },
        filterIconName(value) {
            return this.isFilterActive(value) ? "cancel" : "filter_list";
        },
        cancelFilter(filter) {
            const isActive = this.isFilterActive(this.active[filter]);

            if (!isActive) {
                return;
            }

            this.active[filter] = null;
            this.$emit("update", filter, null);
        },
    },
};
</script>
